import React from 'react';
import InfoField from './InfoField';

const AddressDetailsSection = ({ title, addressData }) => {
  if (!addressData) {
    return (
      <div className="report-section">
        <h2 className="section-title">{title || 'Address Details'}</h2>
        <p>No address details available.</p>
      </div>
    );
  }

  return (
    <div className="admin-report-section">
      <h2 className="admin-section-title">{title || 'Address Details'}</h2>
      <div className="grid-container">
        <InfoField label="Address Line 1" value={addressData.addressLineOne || 'N/A'} />
        <InfoField label="Address Line 2" value={addressData.addressLineTwo || 'N/A'} />
        <InfoField label="Country" value={addressData.country || 'N/A'} />
        <InfoField label="State" value={addressData.state || 'N/A'} />
        <InfoField label="City" value={addressData.city || 'N/A'} />
        <InfoField label="Pincode" value={addressData.pincode || 'N/A'} />
        <InfoField label="Mobile Number" value={addressData.mobileNumber || 'N/A'} />
      </div>
    </div>
  );
};

export default AddressDetailsSection;